module.exports = __webpack_public_path__ + "img/zuqiuzhibo.8aec57cd.png";